// API Configuration
// Automatically detects if running in development or production

const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isDevPort = window.location.port === '3000'; // React dev server typically runs on 3000

// In production (Heroku), use relative URLs since Express serves both frontend and API
// In development, use full localhost URL for the separate backend server
const isInDevelopment = isDevelopment || isLocalhost || isDevPort;

export const API_BASE_URL = isInDevelopment 
  ? 'http://localhost:5000' 
  : '';

// Debug logging (only in development)
if (isInDevelopment) {
  console.log('🔧 API Configuration (Development Mode):');
  console.log('  - NODE_ENV:', process.env.NODE_ENV);
  console.log('  - Hostname:', window.location.hostname);
  console.log('  - Port:', window.location.port);
  console.log('  - API Base URL:', API_BASE_URL);
}

// Helper function to create full API URLs
export const createApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Helper function for making authenticated API calls
export const makeApiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  // Check if body is FormData - if so, don't set Content-Type (let browser set it)
  const isFormData = options.body instanceof FormData;
  
  const defaultHeaders = {
    ...(token && { 'Authorization': `Bearer ${token}` }),
    // Only set Content-Type if not FormData
    ...(!isFormData && { 'Content-Type': 'application/json' })
  };
  
  const mergedOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  };
  
  const url = createApiUrl(endpoint);
  return fetch(url, mergedOptions);
};

export default {
  API_BASE_URL,
  createApiUrl,
  makeApiCall
}; 